import { Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Board from '../boards/Board';
import { MAT_NAME } from '../boards/matConfigs';
import { selectActiveBoard } from '../RightColumn/RightMenu/rightMenuSlice';
import ActiveDiskModal from './ActiveDiskModal';
import Navigation from './Navigation';
import { StyledTabs, TabContent, TabPane } from './styled';

const Tabs = () => {
    const activeBoard = useSelector(selectActiveBoard);

    return (
        <StyledTabs>
            <Tab.Container activeKey={activeBoard}>
                <Navigation />
                <TabContent>
                    <TabPane eventKey={MAT_NAME}>
                        <Board configId={MAT_NAME} />
                    </TabPane>
                </TabContent>
                <ActiveDiskModal />
            </Tab.Container>
        </StyledTabs>
    );
};

export default Tabs;
